//src/styles/custom/transitions.js

const transitions = {
  default: "all 0.3s ease",
  fast: "all 0.15s ease",
  slow: "all 0.5s ease",
  bounce: "all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
};

export default transitions;